import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { supabase } from '@/lib/supabase';
import { useOpportunityWizard } from './OpportunityWizardContext';
import OpportunityWizardLayout from './OpportunityWizardLayout';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

// Since we're not using tenants anymore, let's modify this component to just show the customer details
// and then move directly to the next step

const Step2Tenant = () => {
  const navigate = useNavigate();
  const { state } = useOpportunityWizard();
  const [loading, setLoading] = useState(false);

  // Redirect if no customer selected
  useEffect(() => {
    if (!state.selectedCustomer) {
      navigate('../step1', { relative: 'path' });
    }
  }, [state.selectedCustomer, navigate]);

  const handleNext = () => {
    navigate('../step3', { relative: 'path' });
  };

  return (
    <OpportunityWizardLayout
      currentStep={2}
      totalSteps={7}
      title="Cliente Selecionado"
      description="Confirme os detalhes do cliente para prosseguir"
      onNext={handleNext}
      onPrevious={() => navigate('../step1', { relative: 'path' })}
      isNextDisabled={false}
    >
      <div className="space-y-6">
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <>
            {state.selectedCustomer && (
              <Card className="border-primary">
                <CardContent className="p-6">
                  <div className="space-y-2">
                    <div className="font-extrabold text-xl">
                      {state.selectedCustomer.name}
                    </div>
                    {state.selectedCustomer.legal_name && (
                      <div className="text-muted-foreground">
                        {state.selectedCustomer.legal_name}
                      </div>
                    )}
                    {state.selectedCustomer.business_identification_number && (
                      <div className="text-sm text-muted-foreground">
                        CNPJ: {state.selectedCustomer.business_identification_number}
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            )}
            <div className="text-center text-muted-foreground">
              <p>Clique em "Próximo" para adicionar contatos a essa oportunidade.</p>
            </div>
          </>
        )}
      </div>
    </OpportunityWizardLayout>
  );
};

export default Step2Tenant; 